<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="functions" grid-list-xs>
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Catálogo de Funciones&nbsp;&nbsp;</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        :disabled="bEdit"
                                        text
                                        class="text-none"
                                        v-on="on"
                                    >Nueva Función</v-btn>
                                </template>
                                <v-list color="grey lighten-5">
                                    <v-list-item :disabled="bEdit" @click="onNewPrimary">
                                        <v-list-item-title>Primaria</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item :disabled="bEdit" @click="onNewSpecialized">
                                        <v-list-item-title>Especializada</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        :disabled="(bEdit || selectedSpecializedID === null)"
                                        @click="onNewDisaggregated"
                                    >
                                        <v-list-item-title>Desagregada</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-btn
                                :disabled="(bEdit || functionID === 0 )"
                                text
                                class="text-none"
                                @click="onEditFunction"
                            >Editar Función</v-btn>
                            <v-btn
                                :disabled="(bEdit || functionID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteFunction"
                            >Borrar Función</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewPrimary">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-alpha-p-circle-outline</v-icon>&nbsp; Nueva Función Primaria
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onNewSpecialized">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-alpha-e-circle-outline</v-icon>&nbsp; Nueva Función Especializada
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    :disabled="(bEdit || selectedSpecializedID === null)"
                                    @click="onNewDisaggregated"
                                >
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-alpha-d-circle-outline</v-icon>&nbsp; Nueva Función Desagregada
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditFunction">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">edit</v-icon>&nbsp; Editar Función
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteFunction">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">delete</v-icon>&nbsp; Borrar Función
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <v-container fluid grid-list-xs>
                        <v-layout row>
                            <v-flex xs12>
                                <v-radio-group
                                    :readonly="bEdit"
                                    row
                                    v-model="functionType"
                                    :mandatory="true"
                                >
                                    <v-radio
                                        label="Funciones Primarias"
                                        value="1"
                                        color="orange accent-4"
                                        @change="onPrimaryFunctions"
                                    ></v-radio>
                                    <v-radio
                                        label="Especializadas"
                                        value="2"
                                        color="orange accent-4"
                                        @change="onSpecializedFunctions"
                                        :disabled="!thereAreSpecializedFunctions"
                                    ></v-radio>
                                    <v-radio
                                        label="Desagregadas"
                                        value="3"
                                        color="orange accent-4"
                                        @change="onDisaggregatedFunctions"
                                        :disabled="(functionType === '1') || (!thereAreDisaggregatedFunctions)"
                                    ></v-radio>
                                </v-radio-group>
                            </v-flex>
                        </v-layout>
                        <v-layout row justify-space-around>
                            <v-flex xs4 md2>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Primarias</v-toolbar-title>
                                    </v-toolbar>
                                    <v-list
                                        subheader
                                        dense
                                        style="height: 341px; max-height:100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-5"
                                        :disabled="(functionType !== '1' || bEdit)"
                                    >
                                        <v-list-item-group
                                            v-model="selectedPrimaryIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(funct, i) in primaryFunctions"
                                                :key="i"
                                                @click="selectPrimary(funct.funcionesid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <v-flex xs4 md2>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Especializadas</v-toolbar-title>
                                    </v-toolbar>
                                    <v-list
                                        subheader
                                        dense
                                        style="height: 341px; max-height:100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-5"
                                        :disabled="(functionType !== '2' || bEdit)"
                                    >
                                        <v-list-item-group
                                            v-model="selectedSpecializedIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(funct, i) in specializedFunctionsToShow"
                                                :key="i"
                                                @click="selectSpecialized(funct.funcionesid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>
                            <v-flex xs4 md2>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Desagregadas</v-toolbar-title>
                                    </v-toolbar>
                                    <v-list
                                        subheader
                                        dense
                                        style="height: 341px; max-height:100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-5"
                                        :disabled="(functionType !== '3' || bEdit)"
                                    >
                                        <v-list-item-group
                                            v-model="selectedDisaggregatedIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(funct, i) in disaggregatedFunctionsToShow"
                                                :key="i"
                                                @click="selectDisaggregated(funct.funcionesid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>{{ funct.funcion }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 md5>
                                <v-card color="grey lighten-5">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedFunctionName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>assignment</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        name="nombre"
                                                        label="Función Primaria"
                                                        type="text"
                                                        v-model="primaryName"
                                                        ref="primary_name"
                                                        color="teal darken-3"
                                                        :readonly="!bEditPrimary"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        name="nombre"
                                                        label="Función Especializada"
                                                        type="text"
                                                        v-model="specializedName"
                                                        ref="specialized_name"
                                                        color="teal darken-3"
                                                        :readonly="!bEditSpecialized"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        name="nombre"
                                                        label="Función Desagregada"
                                                        type="text"
                                                        v-model="disaggregatedName"
                                                        ref="disaggregated_name"
                                                        color="teal darken-3"
                                                        :readonly="!bEditDisaggregated"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs4 sm3 md3>
                                                    <v-text-field
                                                        name="nombre"
                                                        label="Contexto"
                                                        type="number"
                                                        v-model="context"
                                                        ref="context_text_field"
                                                        color="teal darken-3"
                                                        :readonly="!bEdit"
                                                        reverse
                                                        prefix="%"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex
                                                    xs4
                                                    sm3
                                                    md3
                                                    offset-xs4
                                                    offset-sm3
                                                    offset-md2
                                                >
                                                    <v-text-field
                                                        name="nombre"
                                                        label="Desafío"
                                                        type="number"
                                                        v-model="challenge"
                                                        ref="challenge_text_field"
                                                        color="teal darken-3"
                                                        :readonly="!bEdit"
                                                        reverse
                                                        prefix="%"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-end row fill-height>
                            <v-flex xs12 sm8 class="text-xs-center text-end">
                                <v-btn
                                    color="pink darken-1"
                                    class="text-none"
                                    text
                                    @click="onClose"
                                    :disabled="bEdit"
                                >Cerrar</v-btn>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para confirmar borrado de función: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingFunction" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Función</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">warning</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la función {{ selectedFunctionName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteFunctionConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteFunction"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de función *************************** -->

                        <!-- Modal para informar que los datos no son válidos: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Información no Válida</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>error_outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">error</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que los datos no son válidos *********************************** -->

                        <!-- Termina renglón para lista de funciones y función seleccionada -->
                    </v-container>
                    <!-- Termina container para lista de funciones y función seleccionada -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'functions',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            bEditPrimary: false,
            bEditSpecialized: false,
            bEditDisaggregated: false,

            bInvalidData: false,
            errorMessage: '',

            functionID: 0,
            functionType: '1', //1 = primarias, 2 = especializadas, 3 = desagregadas (sólo para el radio)

            selectedPrimaryID: null,
            selectedSpecializedID: null,
            selectedDisaggregatedID: null,
            selectedParentID: null,
            selectedFunctionName: '',
            selectedType: 0, //Tipo de la función seleccionada.
            primaryName: '',
            specializedName: '',
            disaggregatedName: '',

            context: '',
            challenge: '',

            bDeletingFunction: false
        };
    },
    created() {
        this.selectFirstPrimary();
    },
    methods: {
        onClose() {
            //Se selecciona la primera primaria, para que no quede seleccionada ninguna función especializada ni desagregada, en caso
            //de que el usuario vuelva a entrar a esta ventana:
            this.specializedFunctionsToShow = [];
            this.disaggregatedFunctionsToShow = [];
            this.selectedSpecializedID = null;
            this.selectedDisaggregatedID = null;

            this.selectFirstPrimary();

            this.$router.push('/');
        },
        onNewPrimary() {
            //Si el radio actual no era el de funciones primarias, se selecciona éste, para que desaparezcan
            //las funciones especializadas y las desagregadas:
            if (this.functionType !== '1') {
                this.functionType = '1';
                this.onPrimaryFunctions();
            }

            this.bEdit = true;
            this.bEditPrimary = true;
            this.bNew = true;
            this.selectedFunctionName = 'Nueva Función Primaria';
            this.selectedFunctionIndex = -1;

            this.functionID = 0;
            this.primaryName = '';
            this.specializedName = '';
            this.disaggregatedName = '';
            this.selectedParentID = 0;
            this.selectedType = 1;
            this.context = 0;
            this.challenge = 0;

            this.$refs.primary_name.focus();
        },
        onNewSpecialized() {
            //Si el radio actual no era el de funciones especializadas, se selecciona éste, para que desaparezcan
            //las funciones desagregadas:
            if (this.functionType !== '2') {
                this.functionType = '2';
                this.onSpecializedFunctions();
            }

            this.bEdit = true;
            this.bEditSpecialized = true;
            this.bNew = true;
            this.selectedFunctionName = 'Nueva Función Especializada';
            this.selectedFunctionIndex = -1;

            this.functionID = 0;
            this.specializedName = '';
            this.disaggregatedName = '';
            this.selectedParentID = this.selectedPrimaryID;
            this.selectedType = 2;
            this.context = 0;
            this.challenge = 0;

            this.$refs.specialized_name.focus();
        },
        onNewDisaggregated() {
            //Si el radio actual no era el de funciones desagregadas, se selecciona éste:
            if (this.functionType !== '3') {
                this.functionType = '3';
                this.onDisaggregatedFunctions();
            }

            this.bEdit = true;
            this.bEditDisaggregated = true;
            this.bNew = true;
            this.selectedFunctionName = 'Nueva Función Desagregada';
            this.selectedFunctionIndex = -1;

            this.functionID = 0;
            this.disaggregatedName = '';
            this.selectedParentID = this.selectedSpecializedID;
            this.selectedType = 3;
            this.context = 0;
            this.challenge = 0;

            this.$refs.disaggregated_name.focus();
        },
        onDeleteFunction() {
            this.bDeletingFunction = true;
        },
        cancelDeleteFunction() {
            this.bDeletingFunction = false;
        },
        deleteFunctionConfirmed() {
            this.bDeletingFunction = false;

            const funct = {
                funcionID: this.functionID,
                tipo: this.selectedType,
                dependencia: this.selectedParentID
            };
            //console.log('función a borrar: ', funct);

            //Si se está borrando una función primaria, después de borrarla se selecciona la primera función primaria:
            if (this.selectedType === 1) {
                this.$store.dispatch('deleteFunction', funct);
                this.selectFirstPrimary();
            }
            //Si se está borrando una función especializada, si además de esta función hay otras,
            //después de borrarla se selecciona la primera función especializada, pero si la función a borrar
            //es la única especializada, entonces se selecciona la función primaria padre:
            else if (this.selectedType === 2) {
                if (this.specializedFunctions.length === 1) {
                    this.$store.dispatch('deleteFunction', funct);
                    this.functionType = '1';
                    this.onPrimaryFunctions();
                } else {
                    //Selecciona la primera función especializada, a menos de que la función que se está
                    //borrando sea la primera, en cuyo caso se selecciona la segunda:
                    if (
                        this.specializedFunctions[0].funcionesid !==
                        funct.funcionID
                    ) {
                        this.selectFirstSpecialized();
                    } else {
                        this.selectSpecialized(
                            this.specializedFunctions[1].funcionesid
                        );
                    }
                    this.$store.dispatch('deleteFunction', funct);
                }
            }
            //Si se está borrando una función desagregada, si además de esta función hay otras,
            //después de borrarla se selecciona la primera función desagregada, pero si la función a borrar
            //es la única desagregada, entonces se selecciona la función especializada padre:
            else if (this.selectedType === 3) {
                if (this.disaggregatedFunctions.length === 1) {
                    this.$store.dispatch('deleteFunction', funct);
                    this.functionType = '2';
                    this.onSpecializedFunctions();
                } else {
                    //Selecciona la primera función desagregada, a menos de que la función que se está
                    //borrando sea la primera, en cuyo caso se selecciona la segunda:
                    if (
                        this.disaggregatedFunctions[0].funcionesid !==
                        funct.funcionID
                    ) {
                        this.selectFirstDisaggregated();
                    } else {
                        this.selectDisaggregated(
                            this.disaggregatedFunctions[1].funcionesid
                        );
                    }
                    this.$store.dispatch('deleteFunction', funct);
                }
            }

            // this.$store.dispatch('deleteFunction', funct);
            // if (this.selectedType === 1) {
            //     this.selectFirstPrimary();
            // } else if (this.selectedType === 2) {
            //     this.selectFirstSpecialized();
            // } else if (this.selectedType === 3) {
            //     this.selectFirstDisaggregated();
            // }
        },
        onEditFunction() {
            this.bEdit = true;
            if (this.selectedType === 1) {
                //Primaria
                this.bEditPrimary = true;
                this.$refs.primary_name.focus();
            } else if (this.selectedType === 2) {
                //Especializada
                this.bEditSpecialized = true;
                this.$refs.specialized_name.focus();
            } else if (this.selectedType === 3) {
                //Desagregada
                this.bEditDisaggregated = true;
                this.$refs.disaggregated_name.focus();
            }
        },
        onCancel() {
            // if (!this.bNew) {
            //Selecciona la función de menor jerarquía seleccionada antes de la edición o el ingreso de los nuevos datos:
            if (this.selectedDisaggregatedID !== null) {
                this.functionType = '3';
                this.selectDisaggregated(this.selectedDisaggregatedID);
            } else if (this.selectedSpecializedID !== null) {
                this.functionType = '2';
                this.selectSpecialized(this.selectedSpecializedID);
            } else {
                this.functionType = '1';
                this.selectPrimary(this.selectedPrimaryID);
            }

            this.bNew = false;
            // } else {
            //     //Vuelve a obtener los datos originales de la función seleccionada:
            //     this.selectPrimary(this.functionID);
            // }
            this.bEdit = false;
            this.bEditPrimary = false;
            this.bEditSpecialized = false;
            this.bEditDisaggregated = false;
        },
        onSave() {
            var name;
            var bDataOK = false;

            if (this.bEditPrimary) {
                name = this.primaryName;
            } else if (this.bEditSpecialized) {
                name = this.specializedName;
            } else if (this.bEditDisaggregated) {
                name = this.disaggregatedName;
            }

            //Se validan los datos:
            if (name === '') {
                this.bInvalidData = true;
                this.errorMessage = 'Teclee el nombre de la función.';
                //PENDIENTE:
                //El siguiente bloque para hacer el focus en el campo correspondiente no funciona, porque el focus se pierde otra vez
                //cuando aparece el modal que indica el mensaje de error. Al parecer el modal en el OK tendría que llamar a una función
                //que ponga el focus en el campo correspondiente, usando variables definidas en data() que indiquen el campo en el que
                //se tiene que poner el focus:
                if (this.selectedType === 1) {
                    this.$refs.primary_name.focus();
                } else if (this.selectedType === 2) {
                    this.$refs.specialized_name.focus();
                } else {
                    this.$refs.disaggregated_name.focus();
                }
            } else if (
                this.context <= 0 ||
                this.context > 200 ||
                this.context === ''
            ) {
                this.bInvalidData = true;
                this.errorMessage = 'El contexto está fuera de rango.';
                this.$refs.context_text_field.focus();
            } else if (
                this.challenge <= 0 ||
                this.challenge > 200 ||
                this.challenge === ''
            ) {
                this.bInvalidData = true;
                this.errorMessage = 'El desafío está fuera de rango.';
                this.$refs.challenge_text_field.focus();
            } else {
                bDataOK = true;
            }

            if (!this.bNew && bDataOK) {
                //Edición de función...
                var functions = [];
                if (this.bEditPrimary) {
                    functions = this.primaryFunctions;
                } else if (this.bEditSpecialized) {
                    functions = this.specializedFunctions;
                } else if (this.bEditDisaggregated) {
                    functions = this.disaggregatedFunctions;
                }

                var i;
                for (i = 0; i < functions.length; i++) {
                    if (functions[i].funcionesid === this.functionID) {
                        const funct = {
                            funcionesid: functions[i].funcionesid,
                            funcion: name,
                            contexto: this.context,
                            desafio: this.challenge,
                            tipo: functions[i].tipo,
                            dependencia: functions[i].dependencia
                        };

                        console.log('Update function: ', funct);
                        //Actualiza el registro en la BD:
                        this.$store.dispatch('updateFunction', funct);

                        break;
                    }
                }
            } else if (this.bNew && bDataOK) {
                //Registro de nueva función...

                const newFunction = {
                    funcion: name,
                    contexto: this.context,
                    desafio: this.challenge,
                    tipo: this.selectedType,
                    dependencia: this.selectedParentID
                };

                console.log('New function: ', newFunction);
                this.$store.dispatch('saveNewFunction', newFunction);

                //Si la nueva función es primaria, se selecciona la primera de las funciones primarias (no la
                //nueva, porque en este momento no se sabe cuál es el ID de la nueva función. Para esto,
                //este método se tendría que hacer desde store.js):
                if (this.selectedType === 1) {
                    this.selectFirstPrimary();
                }
                //Si la nueva función es especializada, se selecciona la primera de las funciones especializadas (no la
                //nueva, porque en este momento no se sabe cuál es el ID de la nueva función. Para esto,
                //este método se tendría que hacer desde store.js):
                else if (this.selectedType === 2) {
                    //Si ya había funciones especializadas, se selecciona la primera, pero si no había funciones especializadas
                    //no se puede seleccionar la primera porque puede ser que el servidor todavía no haya respondido con la información
                    //de esta nueva función, pero como esta función va a ser la primera, lo único que hay que hacer es asignar el
                    //index de la lista a cero (los campos ya fueron llenados por el usuario)...
                    if (this.specializedFunctions.length > 0) {
                        this.selectFirstSpecialized();
                    } else {
                        this.selectedSpecializedIndex = 0;
                    }
                }
                //Si la nueva función es desagregada, se selecciona la primera de las funciones desagregadas (no la
                //nueva, porque en este momento no se sabe cuál es el ID de la nueva función. Para esto,
                //este método se tendría que hacer desde store.js)::
                else if (this.selectedType === 3) {
                    //Si ya había funciones deasgregadas, se selecciona la primera, pero si no había funciones desagregadas
                    //no se puede seleccionar la primera porque puede ser que el servidor todavía no haya respondido con la información
                    //de esta nueva función, pero como esta función va a ser la primera, lo único que hay que hacer es asignar el
                    //index de la lista a cero (los campos ya fueron llenados por el usuario)...
                    if (this.disaggregatedFunctions.length > 0) {
                        this.selectFirstDisaggregated();
                    } else {
                        this.selectedDisaggregatedIndex = 0;
                    }
                }
            }

            if (bDataOK) {
                this.selectedFunctionName = name;
                this.bEdit = false;
                this.bEditPrimary = false;
                this.bEditSpecialized = false;
                this.bEditDisaggregated = false;
                this.bNew = false;
            }
        },
        selectFirstPrimary() {
            console.log('selectFirstPrimary()');
            if (this.primaryFunctions.length > 0) {
                this.selectedPrimaryIndex = 0;
                var primaryID = this.primaryFunctions[this.selectedPrimaryIndex]
                    .funcionesid;
                this.selectPrimary(primaryID);
            } else {
                this.selectedPrimaryIndex = -1;
                //this.primaryID = 0;
            }
        },
        selectPrimary(functionID) {
            if (functionID !== null && functionID !== undefined) {
                //Se llenan campos de contexto y desafío.
                //Se hace un request de los hijos de la función seleccionada.
                //Si hay hijos, se habilita el radio "Especializadas"

                this.selectedPrimaryID = functionID;
                this.functionID = functionID;
                this.selectedType = 1;

                var i;
                for (i = 0; i < this.primaryFunctions.length; i++) {
                    if (this.primaryFunctions[i].funcionesid === functionID) {
                        this.selectedFunctionName = this.primaryFunctions[
                            i
                        ].funcion;
                        this.primaryName = this.primaryFunctions[i].funcion;
                        this.specializedName = ' ';
                        this.disaggregatedName = ' ';
                        this.context = this.primaryFunctions[i].contexto;
                        this.challenge = this.primaryFunctions[i].desafio;

                        var funct = {
                            dependencia: this.primaryFunctions[i].funcionesid,
                            showFunctions: 0 //Indica si specializedFunctionsToShow debe ser llenado.
                        };

                        this.$store.dispatch(
                            'fetchSpecializedFunctions',
                            funct
                        );

                        break;
                    }
                }
            }
        },
        selectFirstSpecialized() {
            if (this.specializedFunctions.length > 0) {
                this.selectedSpecializedIndex = 0;
                var specializedID = this.specializedFunctions[
                    this.selectedSpecializedIndex
                ].funcionesid;
                this.selectSpecialized(specializedID);
            } else {
                this.selectedSpecializedIndex = -1;
                this.specializedID = 0;
                this.onPrimaryFunctions();
            }
        },
        selectSpecialized(functionID) {
            if (functionID !== null && functionID !== undefined) {
                //Se llenan campos de contexto y desafío.
                //Se hace un request de los hijos de la función seleccionada.
                //Si hay hijos, se habilita el radio "Desagregadas"

                this.selectedSpecializedID = functionID;
                this.functionID = functionID;
                this.selectedType = 2;

                var i;
                for (i = 0; i < this.specializedFunctions.length; i++) {
                    if (
                        this.specializedFunctions[i].funcionesid === functionID
                    ) {
                        this.selectedFunctionName = this.specializedFunctions[
                            i
                        ].funcion;
                        this.primaryName = this.specializedFunctions[
                            i
                        ].funcionPrincipal.nombre;

                        this.specializedName = this.specializedFunctions[
                            i
                        ].funcion;
                        this.disaggregatedName = ' ';
                        this.context = this.specializedFunctions[i].contexto;
                        this.challenge = this.specializedFunctions[i].desafio;

                        var funct = {
                            dependencia: this.specializedFunctions[i]
                                .funcionesid,
                            showFunctions: 0 //Indica si disaggregatedFunctionsToShow debe ser llenado.
                        };

                        this.$store.dispatch(
                            'fetchDisaggregatedFunctions',
                            funct
                        );

                        break;
                    }
                }
            }
        },
        selectFirstDisaggregated() {
            if (this.disaggregatedFunctions.length > 0) {
                console.log('disaggregatedFunctions.length > 0...');
                this.selectedDisaggregatedIndex = 0;
                var disaggregatedID = this.disaggregatedFunctions[
                    this.selectedDisaggregatedIndex
                ].funcionesid;
                this.selectDisaggregated(disaggregatedID);
            } else {
                console.log('disaggregatedFunctions.length = 0...');
                this.selectedDisaggregatedIndex = -1;
                this.disaggregatedID = 0;
                this.onSpecializedFunctions();
            }
        },
        selectDisaggregated(functionID) {
            if (functionID !== null && functionID !== undefined) {
                this.selectedDisaggregatedID = functionID;
                this.functionID = functionID;
                this.selectedType = 3;

                var i;
                for (i = 0; i < this.disaggregatedFunctions.length; i++) {
                    if (
                        this.disaggregatedFunctions[i].funcionesid ===
                        functionID
                    ) {
                        this.selectedFunctionName = this.disaggregatedFunctions[
                            i
                        ].funcion;
                        this.primaryName = this.disaggregatedFunctions[
                            i
                        ].funcionPrincipal.nombre;
                        this.specializedName = this.disaggregatedFunctions[
                            i
                        ].funcionEspecializada.nombre;
                        this.disaggregatedName = this.disaggregatedFunctions[
                            i
                        ].funcion;
                        this.context = this.disaggregatedFunctions[i].contexto;
                        this.challenge = this.disaggregatedFunctions[i].desafio;

                        break;
                    }
                }
            }
        },

        onPrimaryFunctions() {
            this.specializedFunctionsToShow = [];
            this.disaggregatedFunctionsToShow = [];
            this.selectedSpecializedID = null;
            this.selectedDisaggregatedID = null;

            this.selectPrimary(this.selectedPrimaryID);
        },
        onSpecializedFunctions() {
            this.specializedFunctionsToShow = this.specializedFunctions;
            this.disaggregatedFunctionsToShow = [];
            this.selectedDisaggregatedID = null;

            if (
                this.selectedSpecializedID === null ||
                this.selectedSpecializedID === undefined
            ) {
                this.selectFirstSpecialized();
            } else {
                this.selectSpecialized(this.selectedSpecializedID);
            }
        },
        onDisaggregatedFunctions() {
            this.disaggregatedFunctionsToShow = this.disaggregatedFunctions;
            if (
                this.selectedDisaggregatedID === null ||
                this.selectedDisaggregatedID === undefined
            ) {
                this.selectFirstDisaggregated();
            } else {
                this.selectDisaggregated(this.selectedDisaggregatedID);
            }
        }
    },
    computed: {
        ...mapGetters([
            'primaryFunctions',
            'specializedFunctions',
            'disaggregatedFunctions',
            'thereAreSpecializedFunctions',
            'thereAreDisaggregatedFunctions',
            'waitCursor'
        ]),
        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
        selectedPrimaryIndex: {
            get() {
                return this.$store.getters.selectedPrimaryIndex;
            },
            set(selectedPrimaryIndex) {
                this.$store.dispatch(
                    'updateSelectedPrimaryIndex',
                    selectedPrimaryIndex
                );
            }
        },
        selectedSpecializedIndex: {
            get() {
                return this.$store.getters.selectedSpecializedIndex;
            },
            set(selectedSpecializedIndex) {
                this.$store.dispatch(
                    'updateSelectedSpecializedIndex',
                    selectedSpecializedIndex
                );
            }
        },
        selectedDisaggregatedIndex: {
            get() {
                return this.$store.getters.selectedDisaggregatedIndex;
            },
            set(selectedDisaggregatedIndex) {
                this.$store.dispatch(
                    'updateSelectedDisaggregatedIndex',
                    selectedDisaggregatedIndex
                );
            }
        },
        specializedFunctionsToShow: {
            get() {
                return this.$store.getters.specializedFunctionsToShow;
            },
            set(specializedFunctionsToShow) {
                this.$store.dispatch(
                    'updateSpecializedFunctionsToShow',
                    specializedFunctionsToShow
                );
            }
        },
        disaggregatedFunctionsToShow: {
            get() {
                return this.$store.getters.disaggregatedFunctionsToShow;
            },
            set(disaggregatedFunctionsToShow) {
                this.$store.dispatch(
                    'updateDisaggregatedFunctionsToShow',
                    disaggregatedFunctionsToShow
                );
            }
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.functions {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}

.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>